import checkIsOrderBumpShownInQuery from './checkIsOrderBumpShownInQuery';

/**
 * Whether an order bump should be hidden from the checkout.
 *
 * Mirrors `isPriceHidden`: a `hidden` placement is removed from the form, but
 * revealed when the URL query lists the bump price's `reference` in
 * `show_order_bumps` (e.g. `?show_order_bumps=price_one_time_fixed_1999`) — the
 * same convention as `show_prices` / `show_fields` / `show_variants`. `hidden`
 * lives on the PLACEMENT, so the same bump can be hidden on one page and not
 * another; `enabled: false` (Disable) is handled by the resolver and is never
 * revealable.
 *
 * Display only: nothing on the write path reads `hidden`, so a revealed bump
 * submits like any other.
 */
export default function isOrderBumpHidden(offer = {}, query = {}) {
  if (!offer.hidden) return false;
  return !checkIsOrderBumpShownInQuery(offer.price?.reference, query);
}
